import './style.sass';

import parse from 'html-react-parser';
import React, { Component } from 'react';
import AnimateHeight from 'react-animate-height';
import CommonCollapseItem from '../../../common-components/common-collapse-item';

class ShowMoreList extends Component {
    state = {
        height: 0,
    };

    toggle = () => {
        const { height } = this.state;

        this.setState({
            height: height === 0 ? 'auto' : 0,
        });
    };

    render() {
        const { height } = this.state;

        const {
            list,
            startIndex = 0,
            btnClassName = '',
            containerListName = '',
            itemListName = '',
            numberColor,
        } = this.props;

        return (
            <div className="hide-list__container">
                <button className={`hide-list__button ${btnClassName}`} onClick={this.toggle}>
                    {height === 0 ? 'Показать еще' : 'Скрыть'}
                </button>

                <AnimateHeight duration={500} height={height}>
                    <div className={containerListName}>
                        {list.map(({ title, subtitle }, index) => (
                            <CommonCollapseItem
                                key={index}
                                index={++index + startIndex}
                                triggerText={title}
                                content={parse(subtitle)}
                                classParent={itemListName}
                                numberColor={numberColor}
                            />
                        ))}
                    </div>
                </AnimateHeight>
            </div>
        );
    }
}

export default ShowMoreList;
